export default {
  getSegmentReFetchInterval: () => 10_000,
  getSegmentResultsReFetchInterval: () => 10_000,
  getSegmentEventsReFetchIntervalWhenFullCalculationStarted: () => 10_000,
  getSegmentEventsReFetchInterval: () => 30_000,
  getScreeningFlowDraftTestRunsReFetchInterval: () => 5_000,
};
